import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchLogisticDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchLogisticDetails, payload);
    const { data } = res;
    yield put(actions.fetchLogisticDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLogisticDetailsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* viewLogisticSaga() {
  yield takeLatest(
    actions.fetchLogisticDetails.type,
    handleFetchLogisticDetails
  );
}
